import $ from 'jquery';
import 'bootstrap';
import {Modal} from 'bootstrap';

import scrollTop from '../../components/scroll-to-top/_index';
import smallHeader from '../../components/small-header/_index';
import scrollToDiv from '../../components/scroll-to-div/_index';


import themeSectorsSlider from './lib/theme/_sectorsSlider';
import themeMap from './lib/theme/_locationMap';
import readmore from '../../gutenberg/lib/block-readmore/_readmore';
import photoWall from '../../gutenberg/lib/block-photo-wall/_index';

import menuItem from './lib/theme/_menuItem';
import imgContainer from './lib/theme/_imgContainer';
import routePlanner from '../../gutenberg/lib/block-route-planner/_index';
let widgetHeight =  $('.navbar__container-top_widget').outerHeight(true);
import eTermin from './lib/theme/_etermin';

$(document).ready(function () {

  scrollTop.init();
  scrollToDiv.init();
  smallHeader.init();
  imgContainer.init();
  readmore.init();
  photoWall.init();

  // menuItem();
  themeSectorsSlider.init();
  themeMap.init();

  menuItem();
  routePlanner.init();
  eTermin.init();

  if (document.getElementById('poepplow-info-modal')) {
    //if cookie hasn't been set...
    if (document.cookie.indexOf("ModalShown=true") < 0) {
      var myModal = new Modal(document.getElementById('poepplow-info-modal'), {
        keyboard: false
      })

      myModal.show()

      poepplowCreateCookie('ModalShown', 'true', 1);
    }
  }


  $('.cmptxt_cookies').click(function (e) {
    e.preventDefault();
    __cmp('showScreen')
  });
});

function poepplowCreateCookie(name, value, days) {
  let expires = '';
  if (days) {
    let d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + d.toGMTString();
  }
  document.cookie = name + '=' + value + expires + '; path=/';
}


$(document).scroll(function () {
  if ($(window).width() < 768) {

    if (window.scrollY >= 50) {
      $('.logo').addClass('logo--small');
      $('.navbar__container-top_widget').css('margin-top', '-' + widgetHeight + 'px');
    } else {
      $('.logo').removeClass('logo--small');
      $('.navbar__container-top_widget').css('margin-top', '0');
    }
  } else {
    $('.logo').removeClass('logo--small');
    $('.navbar__container-top_widget').css('margin-top', '0');
  }
});

$(window).resize(function () {
  if ($(window).width() > 768) {
    $('#navbarNavDropdown').removeClass('show');
    $('.navbar-toggler').attr('aria-expanded', 'false');
    $('.header .toggle-dropdown').removeClass('is-open');
    $('.dropdown-menu').attr('style', '');
    $('.dropdown ul').attr('style', '');
  }
});
